import { apiClient, endpoints } from '.';

export const getUserHomepage = async () => {
	return await apiClient.get(endpoints.getUserHomepage);
};